import { BlurProps, DOMBuilder } from '../../../types';
import styles from './index.scss';
import { assign } from '..';

export class BlurBuilder {
  public static create(
    { creativeUrl, blurEffect, isVertical }: BlurProps,
    domBuilder: DOMBuilder
  ): HTMLElement {
    const container = domBuilder.createElement<HTMLDivElement>('div');
    container.className = styles.blurContainer;

    const background = domBuilder.createElement<HTMLDivElement>('div');
    background.className = styles.blurBackground;

    const scale = 1.1 + blurEffect.zoom / 10;
    const blurStyle: Partial<CSSStyleDeclaration> = {
      top: isVertical ? `${blurEffect.offsetY}px` : '0',
      left: !isVertical ? `${blurEffect.offsetX}px` : '0',
      backgroundImage: `url(${creativeUrl})`,
      transform: `scale(${scale})`
    };

    assign(background.style, blurStyle);
    container.appendChild(background);

    return container;
  }
}
